var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lianbaDownLoad"},[_c('div',{staticClass:"downLoad",on:{"click":_vm.onDownload}},[_vm._v(" 下载联吧 ")]),_c('isWeixinMark',{attrs:{"isWeixin":_vm.isWeixin},on:{"onCancelMark":function($event){_vm.isWeixin = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }